import moment from 'moment-timezone';
import * as $ from 'jquery';
import {environment} from "environments";

class NavbarController {
  /* @ngInject */
  constructor($scope, $log, $interval, $window, $state, $timeout, toastr, Business, Auth, CMS_URL, Users, $rootScope) {
    Object.assign(this, {
      $scope,
      $log,
      $interval,
      $window,
      $state,
      $timeout,
      toastr,
      Business,
      Auth,
      CMS_URL,
      Users,
      $rootScope,
      showSlvAlert: true,
      polls: {},
      slvSchedules: [],
      openStates: [],
      states: "",
      isOpen: false,
      isHoliday: false,
      version: environment.constants.version,
      BOD_1484: ['localhost'].includes(environment.constants.ENV),
    });
    var this2 = this;
    $timeout(() => {
      $("#funnel-hours-id").hover(function () {
        this2.formatOpenStates();

        if (this2.states) {
          $(".open-states-hover").removeClass("hide-slv-states");
        } else {
          $(".open-states-hover").addClass("hide-slv-states");
        }
      }, function () {
        $(".open-states-hover").addClass("hide-slv-states");
      });
    });

    this.isFunnelActive = true;
    $scope.$on('business:slv-status-updated', this._getSlvSchedule.bind(this));
    $scope.$on('business:hours-updated', this._getSlvSchedule.bind(this));
    $scope.$on('business:slv-hours-by-state-updated', this._getSlvSchedule.bind(this));
    $scope.$on('business:holidays-updated', () => {
      this2.Business.isTodayAHoliday().then(isHoliday => {
        this2.isHoliday = isHoliday;
        this2._getSlvSchedule();
      });
    });

    $scope.$watch(() => Auth.profile, (current) => {
      this.profile = current;
      if (this.profile) {
        this.startPolling();
      } else {
        _.each(this.polls, poll => $interval.cancel(poll));
      }
    }, true);
  }

  goToCmsQuestionnaires() {
    if (_.includes(this.Auth.profile.roles, this.Users.ROLES.DOCTOR.NAME)) {
      this.$state.go("cms.services");
    } else {
      this.toastr.warning("This option is restricted to DOCTOR role only.");
    }
  }

  goToCmsContent() {
    this.$window.open(this.CMS_URL, '_blank');
  }

  logout() {
    this.Auth.logout();
  }

  startPolling() {
    var this2 = this;
    this.Business.isTodayAHoliday().then(isHoliday => {
      this2.isHoliday = isHoliday;
      this2.pollEvery15seconds();
      this2.pollEvery60seconds();
      this2.polls.every15seconds = this2.$interval(this2.pollEvery15seconds.bind(this2), 15000);
      this2.polls.every60seconds = this2.$interval(this2.pollEvery60seconds.bind(this2), 60000);
    });
  }

  pollEvery15seconds() {
    this._getSummary();
    this._getActiveUsers();
  }

  pollEvery60seconds() {
    this._getSlvSchedule();
    this._getVideoStatus();
  }

  _getSlvSchedule() {
    this.Business.getSLVSchedules().then(({
      data
    }) => {
      this.slvSchedules = data;
    }).then(() => this.formatOpenStates());
  }

  formatOpenStates() {
    this.states = "";
    this.openStates = [];
    let today = moment().tz('Europe/London').format('dddd|HH|mm').split('|');
    let day_name = today[0];
    let hours = today[1];
    let minutes = today[2];
    let seconds = '00';
    let currentTime = `${hours}:${minutes}:${seconds}`;

    this.slvSchedules.forEach(state => {
      state.days.forEach(day => {
        if (day.day_name === day_name && day.hours[0].close_time >= currentTime && day.hours[0].open_time <= currentTime) {
          this.openStates.push(state.state_code);
        }
      });
    });

    if (this.openStates.length > 0 && !this.isHoliday) {
      this.isOpen = true; // this.states = "AL, AK, CA, CO, IL, MO, AZ, VA, WA, AL, AK, CA, CO, IL, MO, AZ, VA, WA, AL, AK, CA, CO, IL, MO, AZ, VA, WA, AL, AK, CA, CO, IL, MO, AZ, VA, WA, AL, AK, CA, CO, IL, MO, AZ, VA, WA";

      this.states = this.openStates.join(", ");
    } else {
      this.isOpen = false;
    }
  }
  /*
    isTodayAHoliday() {
      this.Business.isTodayAHoliday().then((isHoliday) => {
        this.isHoliday = isHoliday;
      });
    }

    _getHolidays() {
      this.Business.isTodayAHoliday().then((isHoliday) => {
        if (isHoliday) {
          this.schedule = this.schedule || { business: {} };
          Object.assign(this.schedule.business, { open: false });
        }
      });
    }
  */


  _getSummary() {
    this.Business.getSummary().then(({
      data
    }) => this.summary = data);
  }

  updateRefreshStatus() {
    this.Business.getRefreshSummary().then(({
      data
    }) => this.summary = data);
  }

  _getVideoStatus() {
    this.Users.getVideoStatus().then(data => {
      if (!data.data.paused || data.data.paused === 'undefined') {
        this.videoPause = false;
        this.paused_user_id = null;
      } else {
        this.videoPause = true;
        this.paused_user_id = data.data.user_id;
      }
    }).catch(err => {
      console.log("Users.getVideoStatus error: ", err.statusText); // this.toastr.error(err);
    });
  }

  updateVideoStatus() {
    this.Users.updateVideoStatus(!this.videoPause).then(data => {
      this.$rootScope.$broadcast('update-prescriber-pause', !this.videoPause);

      this._getVideoStatus();
    }).catch(err => {
      console.log("Users.updateVideoStatus error: ", err.statusText); // this.toastr.error(err);
    });
  }

  _getActiveUsers() {
    var this2 = this;
    this.Users.getActiveUsers().then(data => {
      var activeUsers = data.data;
      /***************** PLEASE DO NOT DELETE THIS ******************/

      /********** WE USE FOR TESTING 9 DOCTORS ***********/

      /*
      var activeUsers1 = [
        {
          title: "Dr.",
          firstname: "Davis",
          lastname: "Liu",
          active_video_calls: []
        },
        {
          title: "Dr.",
          firstname: "Vijay",
          lastname: "Bhat",
          active_video_calls: [1,2,3]
        },
        {
          title: "Dr.",
          firstname: "Matt",
          lastname: "Walvick",
          active_video_calls: []
        },
        {
          title: "Dr.",
          firstname: "Test1",
          lastname: "Poitier1",
          active_video_calls: [1,2,3]
        },
        {
          title: "Dr.",
          firstname: "Test2",
          lastname: "Poitier2",
          active_video_calls: []
        },
        {
          title: "NP",
          firstname: "Kimberly1",
          lastname: "Hildebrant1",
          active_video_calls: [1,2,3]
        },
        {
          title: "NP",
          firstname: "Kimberly2",
          lastname: "Hildebrant2",
          active_video_calls: []
        },
        {
          title: "NP",
          firstname: "Kimberly3",
          lastname: "Hildebrant3",
          active_video_calls: [1,2,3]
        },
        {
          title: "NP",
          firstname: "Kimberly4",
          lastname: "Hildebrant4",
          active_video_calls: []
        }
        // {
        //   title: "NP",
        //   firstname: "Kimberly5",
        //   lastname: "Hildebrant5",
        //   active_video_calls: [1,2,3]
        // }
      ];
       var activeUsers2 = angular.copy(activeUsers1);
      var activeUsers3 = angular.copy(activeUsers1);
      var activeUsers4 = angular.copy(activeUsers1);
      var activeUsers = activeUsers1.concat(activeUsers2, activeUsers3, activeUsers4);
      console.log(activeUsers);
      */

      activeUsers.forEach(activeUser => {
        activeUser.displayName = activeUser.firstname + ' ' + activeUser.lastname.substring(0, 1) + ". ";

        if (activeUser.user_id === this.paused_user_id) {
          activeUser.active_calls_pause = true;
        } else {
          activeUser.active_calls_pause = false;
        }
      });
      /********** WE USE FOR TESTING 9 DOCTORS ***********/
      // this2.activeUsers = activeUsers1;

      this2.activeUsers = activeUsers;
    }).catch(err => {
      this.toastr.error(err);
    });
  }
  /*
    _getSchedule() {

      this.Business.getSlvSchedule()
      .then(({ data }) => {
        var slvStatus = data;
        var slvStates = [];
        this.showSlvOff = "";

        for(var i = 0; i < slvStatus.length; i++){
          if (slvStatus[i].slv_enabled === 0) {
            slvStates.push(slvStatus[i].code);
          }
        }

        if(slvStates.length > 0){
          this.showSlvOff = " - OFF: ";
        }

        for(var i = 0; i < slvStates.length; i++){

          if(i < slvStates.length-1){
            this.showSlvOff += slvStates[i] + " , "    ;
          }
          else{
            this.showSlvOff += slvStates[i];
          }
        }
      });

      // To get the general SLV availability
      this.Business.getSchedule()
      .then(({ data }) => {

        // TEMPORARY VARIABLE
        // TO AVOID FLICKERING
        this.temp_schedule = data;

        // To get if office is open
        // And also to get the business hours
        // Always checking in Pacific Time (using zip code 94105)
        this.Business.getSlvOpen()
        .then(({ data }) => {

          this.temp_schedule.business = {};
          this.temp_schedule.business.open = data.open;
          this.temp_schedule.business.hours = data.description.substring(4); // WE REMOVE THE STRING ""M-F " AT THE BEGINING

          this.schedule = this.temp_schedule;

          // SPRINT 124
          // PIMS - Improve performance removing polling of GET admin/business/holidays
          // https://app.asana.com/0/1158201371992186/1161696730464683

          // this._getHolidays();
        });
      });
    }
  */


}

NavbarController.$inject = ["$scope", "$log", "$interval", "$window", "$state", "$timeout", "toastr", "Business", "Auth", "CMS_URL", "Users", "$rootScope"];

class NavbarDirective {
  constructor() {
    Object.assign(this, {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: 'NavbarController',
      controllerAs: 'navbar',
      bindToController: true,
    });
  }

}

angular.module('pims').controller('NavbarController', NavbarController);
angular.module('pims').directive('navbar', () => new NavbarDirective());
